import { VectorLayer } from './Layer';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { DevDataService } from '../model/DevDataService';
import { outlineHHS, outlineHHSlow, hhsLabelStyle, outlineRegion, outlineRegionLow, outlineThick } from './MapVectorStyles.js';
import { useEffect, useContext, useState } from 'react';
import { convertGeometryToFeatures } from '../controller/LayerQueries';
import { InterfaceContext } from '../model/InterfaceProvider';

const HHSregionsLayer = (props) => {
    const { map, zoom, zIndex, onLoadStatus = () => {}, downloadRegion } = props;
    const [features, setFeatures] = useState([]);
    const { hhsregion } = useContext(InterfaceContext);
    const [loadStatus, setLoadStatus] = useState(1);
    const [detail, setDetail] = useState('low');

    const staticLabels = [
        { HHSRegID: 1, center: [-7830984.80896299, 5514214.3129521115] },
        { HHSRegID: 2, center: [-8439806.430084273, 5168945.352860589] },
        { HHSRegID: 3, center: [-8815061.51812163, 4788281.18751557] },
        { HHSRegID: 4, center: [-9300801.319483198, 3956239.4193884125] },
        { HHSRegID: 5, center: [-9893443.17087081, 5387651.668677275] },
        { HHSRegID: 6, center: [-11024755.784605857, 3809672.169827702] },
        { HHSRegID: 7, center: [-10751317.676106814, 4543894.631244634] },
        { HHSRegID: 8, center: [-11827965.782098817, 5556199.810650626] },
        { HHSRegID: 9, center: [-13032002.469755, 4461566.60398] },
        { HHSRegID: 9, center: [-17534684.163450003, 2342393.1768] },
        { HHSRegID: 10, center: [-17154880.7069, 9133851.8121] },
        { HHSRegID: 10, center: [-13138657.2565725, 5717115.48675] }
    ];

    const fetchGeometry = async () => {
        setLoadStatus(0);
        const DS = new DevDataService();
        const json = await DS.getGeometryData({ type: 'geometry', scope: 'hhs' });
        const shapes = createBoundaryFeatures(json[0]);
        const labels = createLabelFeatures();
        const features = [...shapes, ...labels];
        // getFeaturedBounds(shapes)
        styleFeatures(features);
        setFeatures(features);
        setLoadStatus(1);
    };
    //ΔVΔVΔ: Used to generate feature bounding boxes for hhs regions in static variables
    const getFeaturedBounds = (shapes) => {
        for (var i = 0; i < shapes.length; i++) {
            var ftr = shapes[i];
            var ext = ftr.getGeometry().getExtent();
            console.log('hhs ftr', ftr);
            console.log(ftr.get('HHSRegID'), ext.join(','));
        }
    };

    const createLabelFeatures = () => {
        return staticLabels.map((shape) => {
            const { HHSRegID, center } = shape;
            const cirFeat = new Feature({
                geometry: new Point(center)
            });
            cirFeat.set('HHSRegID', HHSRegID);
            cirFeat.set('featureType', 'label');
            return cirFeat;
        });
    };
    const createBoundaryFeatures = (json) => {
        const shapes = convertGeometryToFeatures(json, 'topojson');
        return shapes.map((shape) => {
            shape.set('featureType', 'border');
            return shape;
        });
    };
    const styleFeatures = (features) => {
        for (let shape of features) {
            shape.setStyle(null);
            const type = shape.get('featureType');
            const highlighted = downloadRegion === 100 + shape.get('HHSRegID');
            if (hhsregion || highlighted) {
                if (type === 'border' && highlighted) {
                    shape.setStyle(zoom > 6 ? outlineRegion : outlineRegionLow);
                } else if (type === 'border') {
                    shape.setStyle(zoom > 6 ? outlineHHS : outlineHHSlow);
                } else {
                    shape.setStyle(hhsLabelStyle('HHS #' + shape.get('HHSRegID'), highlighted));
                }
            }
        }
    };
    useEffect(() => onLoadStatus(loadStatus), [loadStatus]);
    useEffect(() => map && fetchGeometry(), [map]);
    useEffect(() => map && setDetail(zoom > 6 ? 'high' : 'low'));
    useEffect(() => styleFeatures(features), [detail, hhsregion, downloadRegion]);

    return <VectorLayer title={'hhs'} style={null} visible={hhsregion || downloadRegion} features={features} zIndex={zIndex} map={map} />;
};
export { HHSregionsLayer };
